import { Injectable } from '@angular/core';
import { CustomFormValidators } from '@spartacus/storefront';
import { ResetPasswordComponentService } from '@spartacus/user/profile/components';
import { GonvarriCustomFormValidators } from '../validators/gonvarri-custom-form.validators';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

@Injectable()
export class GonvarriResetPasswordComponentService extends ResetPasswordComponentService {

  protected override passwordValidators = GonvarriCustomFormValidators.passwordValidators;

  override form: UntypedFormGroup = new UntypedFormGroup(
    {
      password: new UntypedFormControl('', [
        Validators.required,
        ...this.passwordValidators,
      ]),
      passwordConfirm: new UntypedFormControl('', Validators.required),
    },
    {
      validators: CustomFormValidators.passwordsMustMatch(
        'password',
        'passwordConfirm'
      ),
    }
  );

}
